<template>
  <div class="info" v-loading='loading'>
    <div class="personal">
      <div class="title">个人资料</div>
      <el-row :gutter="20">
        <el-col :span="6" style="display: flex;">
          <img
            :src="user.AvatarUrl?user.AvatarUrl:'http://expert.ckcest.cn/autoload/images/avatar.png'"
            alt
          />
        </el-col>
        <el-col :span="9">
          <div>用户ID：{{user.No}}</div>
          <div>{{user.Name?'姓名：'+user.Name:''}}</div>
          <div>
            <span>出生日期：{{edit && Birthday !== '1990-01-01'?Birthday:''}}</span>
            <el-date-picker
              v-if='!edit'
              v-model="Birthday"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              @change="getDate"
            ></el-date-picker>
          </div>
        </el-col>
        <el-col :span="9">
          <div>
            <span>所在地：{{edit?user.Province.Name + user.City.Name:''}}</span>
            <el-select v-model="province" placeholder="请选择" @change="selectPro" v-if='!edit'>
              <el-option
                v-for="(item,index) in provinceList"
                :key="item.Id"
                :label="item.ShortName"
                :value="index"
              ></el-option>
            </el-select>
            <el-select v-model="city" placeholder="请选择" @change="selectCity" v-if='!edit'>
              <el-option
                v-for="(item,index) in cityList"
                :key="item.Id"
                :label="item.ShortName"
                :value="index"
              ></el-option>
            </el-select>
          </div>
          <div>最近登录时间：{{user.LastTime?user.LastTime.slice(0,10):''}}</div>
          <div>最近登录IP：{{user.LastIP}}</div>
          <el-button type="info" @click="editInfo">{{edit?'编辑':'保存'}}</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="security">
      <div class="title">账号安全</div>
      <div class="secutity_boby">
        <div class="mrt" style="display:flex">
          <span>安全等级</span>
          <el-progress :stroke-width="24" :percentage="percentage" :format="format"></el-progress>
        </div>
        <div class="mrt" v-if="(user.Email || user.Mobile) && isMobile">
          <span>我的邮箱{{isEmail?'： '+user.Email:''}}</span>
          <el-input v-model="user.Email" v-if="!isEmail" clearable></el-input>
          <el-button type="info" @click="getCode(2)">{{btnEmailTxt}}</el-button>
        </div>
        <div class="mrt">
          <span>绑定手机{{isMobile?'： '+user.Mobile:''}}</span>
          <el-input v-model="user.Mobile" v-if='!isMobile' clearable></el-input>
          <el-button type="info" @click="getCode(1)">{{btnMobileTxt}}</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      title="输入验证码"
      :visible.sync="dialogVisible"
      width="30%"
      min-width='500px'
      close-on-click-modal
      :before-close="handleClose">
      <div v-loading='loading2' style="display:flex;flex-direction: row;">
          <el-input placeholder="请输入手机验证码" v-model="code" style="width:70%;margin-right: 20px;"></el-input>
          <el-button type="primary" :disabled="codeTxt !== '重新获取'" @click="getCode(2)">{{codeTxt}}</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setUser(setIndex)">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getUser, getCity, saveUser, getCode } from '@/api/center'
export default {
  name: 'center',
  props: {
    isHttp: {
      type: String
    }
  },
  data () {
    return {
      /* 用户基本信息 */
      user: JSON.parse(localStorage.getItem('user')),
      Mobile: '',
      Email: '',
      Birthday: '',
      edit: true,
      provinceList: [],
      cityList: [],
      province: '',
      city: '',
      percentage: 0,
      /* 修改信息 */
      editSecu: true,
      isEmail: true,
      isMobile: true,
      btnEmailTxt: '添加',
      btnMobileTxt: '添加',
      /* loading */
      loading: false,
      loading2: false,
      /* 手机验证 */
      codeTxt: '60',
      code: '',
      dialogVisible: false,
      times: 59,
      timer: null,
      setIndex: 0
    }
  },
  methods: {
    format (percentage) {
      return ''
    },
    // 获取用户基本信息
    getUser () {
      this.loading = true
      getUser()
        .then(res => {
          this.user = res.data
          this.Birthday = this.user.Birthday ? this.user.Birthday.slice(0, 10) : ''
          this.province = this.user.Province.Name
          this.city = this.user.City.Name
          this.Email = this.user.Email
          this.Mobile = this.user.Mobile
          if (this.user.Email && this.user.Mobile) {
            this.percentage = 100
          } else if (!this.user.Email && !this.user.Mobile) {
            this.percentage = 0
          } else {
            this.percentage = 50
          }
          if (this.province) {
            this.getCity(this.user.Province.Id)
          }
          if (this.user.Email) {
            this.btnEmailTxt = '编辑'
          }
          if (this.user.Mobile) {
            this.btnMobileTxt = '编辑'
          }
          this.getCity()
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取城市
    getCity (Id) {
      let data = {
        PageSize: 100,
        ParentId: Id || '100000'
      }
      getCity(data)
        .then(res => {
          if (Id) {
            this.cityList = res.data.Data
          } else {
            this.provinceList = res.data.Data
          }
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 选择日期
    getDate (val) {
      this.user.Birthday = val
    },
    // 选择省
    selectPro (index) {
      this.city = ''
      this.user.City.Name = ''
      let id = this.provinceList[index].Id
      this.user.Province = this.provinceList[index]
      this.getCity(id)
    },
    // 选择市
    selectCity (index) {
      this.user.City = this.cityList[index]
    },
    // 编辑信息
    editInfo () {
      this.edit = !this.edit
      if (this.edit) {
        saveUser(this.user).data(res => {})
      }
    },
    // 保存城市
    save () {
      let data = this.user
      if (!this.city) {
        this.$message({
          showClose: true,
          message: '请选择所在地',
          offset: 200
        })
      }
      saveUser(data).then(res => {
        this.$message({
          showClose: true,
          message: res.msg,
          offset: 200
        })
      })
    },
    // 获取验证码
    getCode (index) {
      if (index === 1) {
        this.isMobile = !this.isMobile
        if (!this.isMobile) {
          this.btnMobileTxt = '保存'
          return
        }
        if (!this.user.Mobile) {
          this.$message('请输入手机号')
          this.user.Mobile = this.Mobile
          return
        }
        if (!/^1[3456789]\d{9}$/.test(this.user.Mobile)) {
          this.$message('请输入正确的手机号')
          this.user.Mobile = this.Mobile
          return
        }
      } else if (index === 2) {
        this.isEmail = !this.isEmail
        if (!this.isEmail) {
          this.btnEmailTxt = '保存'
          return
        }
        if (!this.user.Email) {
          this.user.Email = this.Email
          this.$message('请输入邮箱')
          return
        }
        // eslint-disable-next-line no-useless-escape
        if (!/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(this.user.Email)) {
          this.user.Email = this.Email
          this.$message('请输入正确邮箱')
          return
        }
      }
      let data = {
        Mobile: this.user.Mobile,
        Operate: index
      }
      this.setIndex = index
      this.dialogVisible = true
      this.loading2 = true
      getCode(data).then(res => {
        this.loading2 = false
        if (res.status === 1) {
          const TIME_COUNT = 59
          this.times = TIME_COUNT
          this.timer = setInterval(() => {
            if (this.times > 0 && this.times <= 59) {
              this.codeTxt = this.times
              this.times--
            } else {
              this.codeTxt = '重新获取'
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        } else {
          this.dialogVisible = false
          this.$message(res.msg)
        }
      })
    },
    // 修改信息
    setUser (index) {
      this.user.Code = this.code
      this.loading2 = true
      saveUser(this.user).then(res => {
        this.loading2 = false
        if (res.status) {
          if (this.setIndex === 1) {
            this.btnMobileTxt = '编辑'
            this.Mobile = this.user.Mobile
            this.dialogVisible = false
          } else if (this.setIndex === 2) {
            this.btnEmailTxt = '编辑'
            this.Email = this.user.Email
            this.dialogVisible = false
          }
        }
        this.btnMobileTxt = '编辑'
        this.btnEmailTxt = '编辑'
        this.$message({
          showClose: true,
          message: res.msg,
          offset: 200
        })
      })
    }
  },
  watch: {
    dialogVisible: {
      deep: true,
      handler (val) {
        if (val) {
          return
        }
        this.code = ''
        if (this.setIndex === 1) {
          this.user.Mobile = this.Mobile
        } else if (this.setIndex === 2) {
          this.user.Email = this.Email
        }
      }
    }
  },
  mounted () {
    if (localStorage.getItem('user')) {
      this.getUser()
    }
  }
}
</script>

<style lang="scss">
.info {
  .title {
    background: #75867c;
    position: relative;
    margin: auto;
    color: #ffffff;
    width: 16.25rem;
    height: 2.25rem;
    line-height: 2.25rem;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    text-align: center;
    font-size: 1.2rem;
  }
  .personal {
    padding: 0 5%;
    border-top: 2px solid #75867c;
    .el-row {
      margin-top: 40px;
      img {
        margin: auto;
      }
      .el-col {
        line-height: 2.5rem;
        font-size: 1rem;
        .el-date-editor{
          width:150px
        }
        .el-select {
          width: 39%;
        }
        .el-button {
          background: #75867c;
          float: right;
        }
      }
    }
  }
  .security {
    padding: 0 5%;
    border-top: 2px solid #75867c;
    margin-top: 100px;
    padding-bottom: 100px;
    .secutity_boby {
      .mrt {
        margin-top: 40px;
        .el-input {
          margin: 0 10px;
          width: 200px;
        }
        .el-button {
          margin: 0 10px;
          background: #75867c;
        }
        .el-progress {
          margin-left: 20px;
          width: 400px;
          .el-progress-bar__innerText {
            margin: 5px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/menu/info.vue